import { Navigate, useLocation } from "react-router-dom";
import { getItem, removeAll } from "../../utils/Helper";
import { isValidToken } from "../../utils/Jwt";

const ProtectedRoute = ({ children }) => {
  const accessToken = getItem(localStorage, "at");
  const location = useLocation();

  if (accessToken && isValidToken(accessToken)) {
    return children;
  } else {
    removeAll(localStorage);
    return <Navigate to='/login' state={location.pathname} />;
  }
};

export default ProtectedRoute;
